/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { BodyText, Heading, NavigationRouteHierarchy, Paper, Separator, SimpleNavigation } from '@vaisala/rockhopper-components';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProject } from '../state/project';
import { useAuth } from '../state/auth/AuthContext';
import styled from 'styled-components';
import pkg from '../../package.json';
import { PageSpinner } from '../components/PageSpinner'; // Ensure this path is correct

const NavigationInfo = styled(Paper)`
  background-color: var(--vai-button-color-bg-primary);

  .header-color {
    color: var(--vai-color-white);
  }
  .text-color {
    color: var(--vai-button-color-fg-primary);
  }
`;

interface ProjectInfoProps {
  name: string;
  location: string;
  status: string;
}

const InformationSquare: React.FC<ProjectInfoProps> = ({ name, location, status }) => {
  return (
    <NavigationInfo>
      <Separator />
      <Heading level={4} className='header-color'>{name}</Heading>
      <BodyText className='text-color'>Location: {location}</BodyText>
      <BodyText className='text-color'>Status: {status}</BodyText>
    </NavigationInfo>
  );
};

interface NavigationProps {
  collapsed: boolean;
  hierarchy: NavigationRouteHierarchy;
  toggleNav: VoidFunction;
  status: string | null;
}

export const Navigation = ({ collapsed, hierarchy, toggleNav, status }: NavigationProps) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { project, launched } = useProject();
  const { user } = useAuth();

  if (status === 'PENDING') {
    return <PageSpinner />;
  }
  return (
    <SimpleNavigation
      location={pathname}
      collapsed={collapsed}
      onCollapseChange={toggleNav}
      hierarchy={hierarchy}
      productName={
        launched ?
          <InformationSquare
            name={project.name}
            location={project.location}
            status={project.status} /> :
          <>
            <span>{user}</span>
            <br />
            <br />
            <span>{t('app.name') + ` - ${pkg.version}`}</span>
          </>
      }
    />
  );
};
